export enum ESessionType {
  ORIGINAL = 0,
  ASSIGNED = 10,
}
